/**
 * @fileoverview Wires `AccessRefreshPolicy` to window focus: when it says so,
 * the signed-in person's menu is refetched and the sidebar rebuilt.
 */
import { Injectable, inject } from '@angular/core';

import { AuthService } from './auth.service';
import { SidebarService } from './sidebar.service';
import { AccessRefreshPolicy } from './access-refresh';

@Injectable({ providedIn: 'root' })
export class AccessRefreshService {
  private auth = inject(AuthService);
  private sidebar = inject(SidebarService);
  /* Short, only to absorb the focus + visibilitychange pair one tab switch fires. */
  private policy = new AccessRefreshPolicy({ now: () => Date.now(), minIntervalMs: 5_000 });
  private started = false;

  start(): void {
    if (this.started || typeof window === 'undefined') return;
    this.started = true;
    const onReturn = () => {
      if (this.policy.onFocus()) this.reload();
    };
    window.addEventListener('focus', onReturn);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') onReturn();
    });
  }

  /** Silent: the sidebar is rebuilt only when the fetched settings differ from the loaded ones. */
  private reload(): void {
    if (!this.auth.isAuthenticated()) return;
    this.auth.refreshPermissionsIfChanged().subscribe({
      next: (changed) => {
        if (changed) this.sidebar.callSidebarMethod();
      },
      error: () => undefined,
    });
  }
}
